import React, { useState } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { useDispatch, useSelector } from "react-redux";
import { saveForumQuestion, loadForumData } from "./Slice/questionSlice";
import PropTypes from "prop-types";

const Question = (props) => {

  const { userdata } = props;
  const dispatch = useDispatch();
  const { success, error } = useSelector((state) => state?.question);
  const { register, formState: { errors }, handleSubmit } = useForm();
  const [getLoader, setGetLoader] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  console.log("", popupMessage);

  const onSubmit = (data) => {
    setGetLoader(true);
    dispatch(
      saveForumQuestion({
        user_id: userdata.user_id,
        question: data.question,
        category: data.category,
      })
    )
      .unwrap()
      .then((result) => {
        // refresh forum list
        dispatch(loadForumData(userdata.user_id));
        setPopupMessage(result.message);
        setShowPopup(true);
      })
      .catch((err) => {
        setPopupMessage(err);
        setShowPopup(true);
      })
      .finally(() => {
        setGetLoader(false);
      });
  };


  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered className="calendar-modal"
      >
        <Modal.Header closeButton><h3><b>Ask a Question</b></h3></Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="mentor_detail align-items-center">
              <Col sm={12}>
                <div className="form-group">
                  <label className="form-label" htmlFor="category">Category</label>
                  <Form.Control
                    as="select"
                    className="mb-3"
                    name="category"
                    {...register("category", {
                      required: true
                    })}
                  >
                    <option value="" key="">Select Option</option>
                    {/* {userdata.categories && */}
                      {userdata.categories.map((item) => (
                        <option
                          value={item.id}
                          key={item.id}
                        >
                          {item.category}
                        </option>
                      ))}
                  </Form.Control>
                  {errors?.category && errors?.category?.type === "required" && (
                    <label className="customeValidationText text-left" htmlFor="category">
                      Please select category
                    </label>
                  )}
                </div>
              </Col>
              <Col sm={12}>
                <label className="form-label" htmlFor="question">Question</label>
                <Form.Control
                  as="textarea"
                  className={
                    errors?.question ? "form-control is-invalid" : "form-control"
                  }
                  name="question"
                  defaultValue=''
                  aria-invalid={errors?.question ? "true" : "false"}
                  {...register("question", {
                    maxLength: 250,
                    required: true
                  })}
                />
                {errors?.question && errors?.question?.type === "required" && (
                  <label className="customeValidationText text-left" htmlFor="question">
                    Please enter question
                  </label>
                )}
                {errors?.question && errors?.question?.type === "maxLength" && (
                  <label className="customeValidationText text-left" htmlFor="question">
                    Question should not more than 250 characters
                  </label>
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <div className="form-group mt-3 text-left">
                  <Button
                    className="btn nextbtn ml-2"
                    type="submit"
                    disabled={getLoader}
                  >
                    {getLoader ? 'Submitting...' : 'Submit Question'}

                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false);
          props.onHide();
        }}
        message={success || error}
        showConfirm={false}
        staticBackdrop={true}
      />

    </>
  );
};

Question.propTypes = {
  userdata: PropTypes.shape({
    user_id: PropTypes.number,
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        category: PropTypes.string,
      })
    ),
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Question;
